import { router } from 'expo-router';

import type { Command } from './types';

import { authService } from '@/services/auth-service';
import { dataService } from '@/services/data-service';
import { TaskStatus } from '@/types/models';

export const quickTaskCommand: Command = {
	id: 'quick-task',
	title: 'Quick Task',
	description: 'Quickly create a task (e.g., /task Call Lynn)',
	icon: 'flash-outline',
	category: 'create',
	keywords: ['task', 'quick', 'todo'],
	prefix: 'task',
	action: (closeSearch) => {
		router.push('/tasks/new');
		closeSearch?.();
	},
	inlineAction: async (args, closeSearch) => {
		try {
			const user = await authService.getUser();
			await dataService.createTask({
				title: args,
				status: TaskStatus.Open,
				assignedTo: user?.id,
			});
			closeSearch?.();
		} catch (error) {
			console.error('Failed to create quick task:', error);
		}
	},
};
